import React, { useState } from 'react'
import { Form, Link } from "../../plugins/gatsby-plugin-atollon";
import { RightArrow, Loading, Upload } from './icons';
import Select from 'react-select'
import AnimationButton from "./structured-text/blocks/animation-button";

const FormComponent = (props) => {

  const staticValues = {}

  if (props.title) {
    staticValues['product'] = props.title
  }
  if (props.promoTitle) {
    staticValues['promo'] = props.promoTitle
  }

  return (
    <Form
      schema={props.form}
      onPreSubmit={props.onPreSubmit}
      onSubmitSuccess={props.onSubmitSuccess}
      values={staticValues}
      renderField={(field) => {
        if (field.type === "text" || field.type === "email" || field.type === "tel") {
          let defaultValue = field.label === 'Product' ? props.title : undefined
          if (field.label === 'Product') defaultValue = props.title
          let defaultType = (field.label === 'Product') ? 'hidden' : field.type
          return (
            <div className={`form__text${field.label === 'Product' ? ' form__hidden' : ''}`}>
              <label htmlFor={field.id}>
                {field.label}{field.required ? '*' : ''}
              </label>
              <input
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                type={defaultType}
                defaultValue={defaultValue}
                value={defaultValue}
                id={field.id}
                maxLength={field.label === 'Postcode' ? 6 : undefined}
                autoComplete={field.autoComplete}
                placeholder={defaultValue ? defaultValue : field.placeholder}
                aria-required={field.required}
                disabled={field.label === 'Product' ? true : field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
              />
              {field.hasErrors && (
                <div role="alert">{field.errors.join(", ")}</div>
              )}
            </div>
          )
        }
        if (field.type === 'file') {
          return (
            <div className='form__file'>
              <label className='form__file-label'>
                {field.label}
              </label>
              <div className='form__dropzone dropzone form__file-dropzone'>
                { field.files ?
                  <div className='dropzone__content'>
                    {field.files.map((file) => (
                      <p key={file.name}>{file.name}</p>
                    ))}
                  </div>
                :
                  <div className='dropzone__content'>
                      {field.hasErrors ? (
                          <>
                              <p><strong>There was an issue uploading your file.</strong></p>
                              <div role="alert">{field.errors.join(", ")}</div>
                          </>
                      ) : (
                          <>
                              <Upload color='#000' />
                              <h3>Drag and drop</h3>
                              <p className='dropzone__type'>{field.options?.map(el => el.label).join(', ')} <br />
                              Maximum File Size 20 MB</p>
                              <p>or</p>
                              <p><span>Browse</span></p>
                          </>
                    )}
                  </div>
                }
                <div className='dropzone__button'>
                  <div className='btn'>
                    <input
                        ref={field.ref}
                        onBlur={field.onBlur}
                        onChange={field.onChange}
                        onClick={field.onClick}
                        accept={field.accept}
                        multiple={field.multiple}
                        onDrop={field.onDrop}
                        name={field.name}
                        type={field.type}
                        id={field.id}
                        placeholder={field.placeholder}
                        aria-required={field.required}
                        disabled={field.disabled}
                        aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                        aria-invalid={field?.invalid}
                    />
                    {field.isUploadingFile && "Uploading..."}
                    {field.fileUploadSuccessful && "Uploaded"}
                  </div>
                </div>
              </div>
              { props.form.title === 'Promo Form' && 
                <div className='form__promo-terms'>By clicking ‘Submit Entry’ you agree to the <Link to='/edlyn/terms-conditions-crown-melbourne-competition'>Promotion T&C’s</Link></div>
              }
              { props.form.title === 'Aus Open' && 
                <div className='form__promo-terms'>By clicking ‘Enter you agree to the <Link to='/sunnyside/terms-conditions'>Promotion T&C’s</Link></div>
              }
            </div>
          )
        }
        if (field.type === "textarea") {
          return (
            <div className='form__textarea'>
              <label htmlFor={field.id}>
                  {field.label}{field.required ? '*' : ''}
              </label>
              <textarea
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                id={field.id}
                placeholder={field.placeholder}
                aria-required={field.required}
                disabled={field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
              />
              {field.hasErrors && (
                <div role="alert">{field.errors.join(", ")}</div>
              )}
            </div>
          )
        }
        if (field.type === "select") {
          let options = []
          field.options.map((option) => (
            options.push({ value: option.value, label: option.label })
          ))
          const handleTypeSelect = (e) => {
            let event = {
              target: {
                name: field.name,
                value: e.value
              }
            }
            field.onChange(event)
          };
          return (
            <>
              {field.name === 'beds' && <p className='form__p'>I’m interested in properties that have</p> }
              <div className={`form__select form__select--${field.name}`}>
                <label htmlFor={field.id}>
                  {field.label}{field.required ? '*' : ''}
                </label>
                <Select
                  classNamePrefix='react-select'
                  ref={field.ref}
                  onBlur={field.onBlur}
                  onChange={handleTypeSelect}
                  id={field.id}
                  name={field.name}
                  aria-required={field.required}
                  disabled={field.disabled}
                  aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                  aria-invalid={field?.invalid}
                  options={options}
                  placeholder={field.placeholder}
                  isSearchable={false}
                />
                {field.hasErrors && (
                  <div role="alert">{field.errors.join(", ")}</div>
                )}
              </div>
            </>
          )
        }
        if (field.type === "radio") {
          return (
            <div className='form__radio'>
              <label className='label'>
                {field.label}{field.required ? '*' : ''}
              </label>
              {field.options.map((option) => (
                <div className='form__radio-wrapper'>
                  <input
                    id={option.id}
                    type="radio"
                    value={option.value}
                    ref={field.ref}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    name={field.name}
                    aria-required={field.required}
                    disabled={field.disabled}
                    aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                    aria-invalid={field?.invalid}
                  />
                  <label htmlFor={option.id}>{option.label}</label>
                </div>
              ))}
              {field.hasErrors && (
                <div role="alert">{field.errors.join(", ")}</div>
              )}
            </div>
          )
        }

        if (field.type === "checkbox") {
          return (
            <div className={`form__checkbox${field.label === 'Property Management' ? ' form__checkbox--last' : ''}${field.label === 'Request Section 32' ? ' form__checkbox--hide' : ''}`}>
              <input
                type="checkbox"
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                id={field.id}
                aria-required={field.required}
                disabled={field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
                defaultChecked={field.label === 'Request Section 32' && props.sectionThirtyTwo ? true : undefined}
              />
              <label htmlFor={field.id}>
                {field.label}
              </label>
              {field.hasErrors && (
                <div role="alert">{field.errors.join(", ")}</div>
              )}
            </div>
          )
        }

          if (field.type === "checkboxes") {
              return (
                  <div className='form__checkboxes'>
                      <label className='form__checkboxes-label'>
                        {field.label}
                      </label>
                      {field.options.map((option) => (
                          <div className="form__checkbox">
                              <input
                                  type="checkbox"
                                  ref={field.ref}
                                  onBlur={field.onBlur}
                                  onChange={field.onChange}
                                  name={field.name}
                                  id={option.id}
                                  aria-required={field.required}
                                  disabled={field.disabled}
                                  aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                                  aria-invalid={field?.invalid}
                                  value={option.value}
                              />
                              <label htmlFor={option.id}>
                                  {option.label}
                              </label>
                          </div>
                      ))}
                      {field.hasErrors && (
                          <div role="alert">{field.errors.join(", ")}</div>
                      )}
                  </div>
              )
          }
        return (
          <div>field</div>
        )
      }}
      renderApiErrors={({ errors }) => (
        <div role="alert" className="api-error">{errors.join(", ")}</div>
      )}
      renderSubmitButton={({ children }) => ( <div className='form__submit'><AnimationButton form={true} className='btn btn--animation' type="submit">{props.form.title === 'Subscribe' ? '' : children} <RightArrow /></AnimationButton></div>) }
      renderConfirmationMessage={({ message }) => (
        <div className='form__confirmation'>{message}</div>
      )}
      renderLoadingSpinner={() => <div className='form__loading'><Loading /></div>}
    />
  )
}

export default FormComponent
